export default __webpack_public_path__ + "static/media/play-circle.59bea656.svg";